import { useCallback } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useGetIsSplitTestSelector = () => {
  const state = useGetEditOrActual();

  return useCallback((id: string) => !!state.splitTests[id], [state.splitTests]);
};
